// components/Navbar.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../css/Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          🎯 Naga's Smart Portfolio
        </Link>
        
        <div className="navbar-menu">
          <Link 
            to="/" 
            className={`navbar-item ${isActive('/') ? 'active' : ''}`}
          >
            Home
          </Link>
          
          {user ? (
            <>
              <Link 
                to="/portfolio" 
                className={`navbar-item ${isActive('/portfolio') ? 'active' : ''}`}
              >
                Portfolio
              </Link>
              <Link 
                to="/risk" 
                className={`navbar-item ${isActive('/risk') ? 'active' : ''}`}
              >
                Risk Management
              </Link>              
              <Link 
                to="/stocks" 
                className={`navbar-item ${isActive('/stocks') ? 'active' : ''}`}
              >
                Stock Finder
              </Link>              

              <Link 
                to="/dashboard" 
                className={`navbar-item ${isActive('/dashboard') ? 'active' : ''}`}
              >
                Dashboard
              </Link>
              <Link 
                to="/tradeOperation" 
                className={`navbar-item ${isActive('/tradeOperation') ? 'active' : ''}`}
              >
                Trade Operation
              </Link>              
              <button onClick={logout} className="navbar-item logout-btn">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className={`navbar-item ${isActive('/login') ? 'active' : ''}`}>
                Login
              </Link>
              <Link to="/registration" className={`navbar-item ${isActive('/registration') ? 'active' : ''}`}>
                Register
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;